import React from 'react';
import i18n from '../../../../i18n';
import { Link } from 'react-router-dom';
import { Grid, Hidden } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Footer } from 'components/Footer/Footer';
import { ErrorBoundary } from 'components/ErrorBoundary';
import { Icon } from 'components/Icon/Icon';
import { Button, ButtonColor } from 'components/Button/Button';
import { Text, TextTypography } from 'components/Text/Text';
import { WelcomePopup } from './WelcomePopup';

import { RoutePath } from 'RoutePath';

import { ReactComponent as CatalogIcon } from 'assets/glyphs/catalog.svg';
import { ReactComponent as PlusIcon } from 'assets/icons/main-16/plus--16.svg';
import { useSelector } from 'react-redux';
import { authStoreCategorySelector } from 'state/auth/selectors';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        height: '100%',
    },
    spacer: {
        flex: 1,
    },
    content: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            height: '100%',
            flexGrow: 1,
            paddingBottom: 100,
        },
    },
    addProductButtonWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        position: 'absolute',
        right: 40,
        bottom: 68,
    },
    welcomeContainer: {
        marginBottom: 24,
    },
    addProductButton: {
        padding: '12px 16px',
        height: 48,
    },
    addProductMobileButton: {
        padding: '12px 0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderBottom: '1px solid rgba(15, 24, 37, 0.05)',
    },
    addProductMobileButtonIcon: {
        marginRight: 8,
    },
    title: {
        maxWidth: 300,
        margin: '0 auto',
        marginTop: theme.spacing(3.5),
        marginBottom: theme.spacing(3),
    },
    footer: {
        flexGrow: 0,
        flexBasis: 'auto',
        marginTop: theme.spacing(2),
        padding: 0,
        paddingBottom: theme.spacing(4),
        borderTop: '1px solid rgba(15, 24, 37, 0.05)',
    },
    footerControls: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: theme.spacing(4),
        paddingTop: theme.spacing(3),
        paddingRight: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        width: '100%',
    },
    footerControlsButton: {
        width: '100%',
        height: 48,
    },
}));

export const CatalogEmpty = () => {
    const classes = useStyles();
    const { t } = i18n.useTranslation();
    const isStoreRegistration = window.location.pathname === RoutePath.REGISTRATION_CATALOG;
    const storeCategory = useSelector(authStoreCategorySelector);
    return (
        <ErrorBoundary>
            <div className={classes.container}>
                <Hidden smUp>
                    <div className={classes.spacer} />
                </Hidden>
                <div className={classes.content}>
                    <Icon component={CatalogIcon} size={64} svgSize={64} />
                    <div className={classes.title}>
                        <Text typography={TextTypography.DISPLAY_STRONG}>
                            {t(`onboarding:emptyCatalog.storeCategory.${storeCategory}`)}
                        </Text>
                    </div>
                    <Hidden xsDown>
                        <div className={classes.addProductButtonWrapper}>
                            <div className={classes.welcomeContainer}>
                                <WelcomePopup />
                            </div>
                            <Link
                                to={
                                    isStoreRegistration
                                        ? RoutePath.REGISTRATION_CATALOG_ADD
                                        : RoutePath.VENDOR_CATALOG_ADD
                                }
                            >
                                <Button className={classes.addProductButton} color={ButtonColor.DARK}>
                                    {t('onboarding:emptyCatalog.addButton')}
                                </Button>
                            </Link>
                        </div>
                    </Hidden>
                    <Hidden smUp>
                        <WelcomePopup />
                    </Hidden>
                </div>
                <Hidden smUp>
                    <Footer className={classes.footer}>
                        <Grid container direction={'row'} justify={'center'}>
                            <Grid item xs={12}>
                                <div>
                                    <Link
                                        to={
                                            isStoreRegistration
                                                ? RoutePath.REGISTRATION_CATALOG_ADD
                                                : RoutePath.VENDOR_CATALOG_ADD
                                        }
                                    >
                                        <div className={classes.addProductMobileButton}>
                                            <Icon
                                                className={classes.addProductMobileButtonIcon}
                                                component={PlusIcon}
                                                size={16}
                                                svgSize={16}
                                                color="#243143"
                                            />

                                            <Text typography={TextTypography.PARA_ACCENT}>
                                                {t('onboarding:emptyCatalog.addButton')}
                                            </Text>
                                        </div>
                                    </Link>
                                </div>
                            </Grid>
                            {isStoreRegistration ? (
                                <div className={classes.footerControls}>
                                    <Button
                                        className={classes.footerControlsButton}
                                        disabled={true}
                                        color={ButtonColor.DARK}
                                    >
                                        {t('onboarding:footer.nextButton')}
                                    </Button>
                                </div>
                            ) : (
                                <div style={{ height: 70 }} />
                            )}
                        </Grid>
                    </Footer>
                </Hidden>
            </div>
        </ErrorBoundary>
    );
};
